import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

function getInitialFilter() {
  return {
    search: "",
    state: "",
    zipCode: "",
    radius: "",
    studentBody: "",
    collegeType: "",
    degreeType: "",
    ranking: "",
    fieldOfStudy: "",
    campusSetting: [],
    typeOfInstitution: [],
    location: null,
  };
}

const collegeSlice = createSlice({
  name: "college",
  initialState: {
    initialFilter: getInitialFilter(),
    filters: getInitialFilter(),
    collegeListLoading: false,
    collegeList: [],
  },
  reducers: {
    setCollegeList(state, action) {
      state.collegeList = action.payload;
    },
    setFilters(state, action) {
      const filters = action.payload;
      for (const key in filters) {
        if (filters[key] === "none") {
          filters[key] = null;
        }
      }
      const isFiltersEqual = _.isEqual(state.filters, filters);
      if (!isFiltersEqual) {
        state.filters = filters;
        state.collegeListLoading = true;
      }
    },
    resetFilters(state) {
      state.filters = getInitialFilter();
    },
    setCollegeListLoading(state, action) {
      state.collegeListLoading = action.payload;
    },
  },
});

export const collegeActions = collegeSlice.actions;
export default collegeSlice.reducer;
